import { render } from "./WarrantyClaimLineAttachments.vue?vue&type=template&id=1f97320b"
import script from "./WarrantyClaimLineAttachments.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimLineAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__